/* eslint-disable @typescript-eslint/method-signature-style */

/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   location utilities
 */

import { isNumber } from '@zcode/utils'

import type { AutocompleteBoxType, BoundsObj, BoxTuple, MaybeNullBoundsObj } from '../../types'
import { chomp } from '../chomp'

import { boxToQueryBounds } from './boxToQueryBounds'

/**
 * convert a bounds {String|Object|MapBounds} to 'object min/max Lat/Lng form
 *
 */
export function getQueryBounds(bounds: null | undefined, precision?: number): undefined
export function getQueryBounds(bounds: BoundsObj, precision?: number): BoundsObj
export function getQueryBounds(
  bounds: `${number},${number},${number},${number}`,
  precision?: number
): BoundsObj
export function getQueryBounds(bounds: string, precision?: number): BoundsObj | undefined
export function getQueryBounds(bounds: BoxTuple | readonly number[], precision?: number): BoundsObj
export function getQueryBounds<T extends MaybeNullBoundsObj>(bounds: T, precision?: number): T
// export function getQueryBounds(
//   bounds: MaybeNullBoundsObj | BoxTuple | readonly number[] | string | null | undefined,
//   precision?: number
// ): MaybeNullBoundsObj | undefined
export function getQueryBounds(bounds: any, precision?: number): MaybeNullBoundsObj | undefined
export function getQueryBounds(
  bounds:
    | AutocompleteBoxType
    | MaybeNullBoundsObj
    | BoxTuple
    | readonly number[]
    | string
    | null
    | undefined,
  precision?: number
): MaybeNullBoundsObj | undefined {
  if (!bounds) {
    return undefined
  }
  if (typeof bounds === 'string') {
    const box = bounds.split(',').map(Number).filter(isNumber)
    if (box.length !== 4) {
      return undefined
    }
    return boxToQueryBounds(box as unknown as BoxTuple)
  }
  if (Array.isArray(bounds)) {
    if (bounds.length !== 4) {
      return undefined
    }
    return boxToQueryBounds(bounds as unknown as BoxTuple)
  }
  const maxLat = isNumber(bounds.maxLat) ? bounds.maxLat : null
  const maxLng = isNumber(bounds.maxLng) ? bounds.maxLng : null
  const minLat = isNumber(bounds.minLat) ? bounds.minLat : null
  const minLng = isNumber(bounds.minLng) ? bounds.minLng : null

  return {
    maxLat: isNumber(precision) && maxLat ? chomp(maxLat, precision) : maxLat,
    maxLng: isNumber(precision) && maxLng ? chomp(maxLng, precision) : maxLng,
    minLat: isNumber(precision) && minLat ? chomp(minLat, precision) : minLat,
    minLng: isNumber(precision) && minLng ? chomp(minLng, precision) : minLng,
  }
}
